// Only themes are allowed to import scss files.
// eslint-disable-next-line import/no-unassigned-import
import '../../../../scss/themes/default/default.scss';

function AndersTheme() {
    return null;
}

export default AndersTheme;
